import React from 'react';
import VersionsListingStyled from './VersionsListing.styled';
import { useSelector } from 'react-redux';
import VersionCard, { VersionCardProps } from '@/components/cards/VersionCard';
import { getSelectedBlockId } from '@/redux/selectors/app';

interface VersionListingProps {
  getSelectedVersion: any;
  setSelectedVersion: any;
  branches: any[];
}

const VersionListing = ({
  setSelectedVersion,
  getSelectedVersion,
  branches,
}: VersionListingProps) => {
  const blockId = useSelector(getSelectedBlockId);

  return (
    <VersionsListingStyled>
      <ul
        role="radiogroup"
        aria-labelledby="version-listing"
        id="version-listing"
      >
        <li id="versions-listing" className="sr-only">
          Version Listing
        </li>
        {branches?.map((v: VersionCardProps, i: number) => {
          return (
            <VersionCard
              {...v}
              key={i}
              isSelected={getSelectedVersion(v)}
              action={() => setSelectedVersion({ ...v, blockId })}
            />
          );
        })}
      </ul>
    </VersionsListingStyled>
  );
};

export default VersionListing;
